module.exports = __webpack_public_path__ + "media/745a4f04-c411-5732-b787-fc73d7928ffa_Trim.32d48f2b.mp4";